import { subscriptionPlans } from '@/common/constants'

import { returnMethodsWithCarrierSetup } from '../constants'

export const shouldShowAdditionalConfiguration = (deliveryMethodType, subscriptionPlan) => {
  return returnMethodsWithCarrierSetup.includes(deliveryMethodType) && subscriptionPlan !== subscriptionPlans.basic
}
